// activeSafetyForms/nearMiss/state.js

import { nearMissFormInitialState } from "../../forms/nearMissForm/nearMissFormState";

export const activeNearMissInitialState = {
  tabName: "nearMiss", // Identifies this tab
  isLoading: false,
  error: null,
  nearMissMode: null,
  currentNearMiss: null,
  nearMissErrors: null,
  rev: 0, // Revision for the autosave hook to reference
  nearMissForm: nearMissFormInitialState, // Nested UI state
};
